import { differenceInCalendarDays, isToday } from 'date-fns';

const SHORT_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

const SHORT_WEEKDAY_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'short',
};

const SHORT_MONTH_DAY_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
};

const FULL_DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: 'long',
  timeStyle: 'short',
};

function parseDate(value: Date | string): Date | null {
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getDateTimeDisplay(value: Date | string): { shortLabel: string; fullLabel: string } {
  const date = parseDate(value);
  if (!date) {
    return { shortLabel: '', fullLabel: '' };
  }

  const now = new Date();
  const dayDifference = differenceInCalendarDays(now, date);

  if (isToday(date)) {
    return {
      shortLabel: date.toLocaleTimeString(undefined, SHORT_TIME_OPTIONS),
      fullLabel: date.toLocaleString(undefined, FULL_DATE_TIME_OPTIONS),
    };
  }

  if (Math.abs(dayDifference) < 7) {
    return {
      shortLabel: date.toLocaleDateString(undefined, SHORT_WEEKDAY_OPTIONS),
      fullLabel: date.toLocaleString(undefined, FULL_DATE_TIME_OPTIONS),
    };
  }

  return {
    shortLabel: date.toLocaleDateString(undefined, SHORT_MONTH_DAY_OPTIONS),
    fullLabel: date.toLocaleString(undefined, FULL_DATE_TIME_OPTIONS),
  };
}

export function formatShortDateTime(value: Date | string): string {
  return getDateTimeDisplay(value).shortLabel;
}

export function formatFullDateTime(value: Date | string): string {
  return getDateTimeDisplay(value).fullLabel;
}
